module.exports = __webpack_public_path__ + "assets/img/button.83ddd221.svg";